module.exports = __webpack_public_path__ + "static/media/cozy9108.5fec23be.jpg";